import BottomDrawer from "./bottomDrawer/BottomDrawer";

const ButtonChat = () => {
  return <BottomDrawer />;
};

export default ButtonChat;
